import React from 'react';
import { Result } from 'antd';
import { CONTACT_PHONE } from '../../constants';


const FormError = () => {
    return (
        <Result
            status="error"
            title="Submission Failed"
            subTitle={
                <span>
                    There was an error processing your request.
                    <br />
                    If you still with to make a booking, please contact us directly on { CONTACT_PHONE }.
                </span>
            }
        />
    );
};

export default FormError;
